import * as XLSX from 'xlsx';
import { EmployeeRow } from './types';

const REQUIRED_HEADERS = ['ASA', 'ŞV seriya №', 'FİN', 'Mobil nömrə', 'Vəzifə'];

export const parseExcel = (file: File): Promise<EmployeeRow[]> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = e => {
      try {
        const data = e.target?.result;
        if (!data) return reject('No data');

        const wb = XLSX.read(data, { type: 'array' });
        const sheet = wb.Sheets[wb.SheetNames[0]];

        const rows: any[][] = XLSX.utils.sheet_to_json(sheet, {
          header: 1, // ← array of arrays
          defval: '',
        });

        if (!rows.length) {
          resolve([]);

          return;
        }

        const [headerRow, ...dataRows] = rows;

        const headerIndexMap = headerRow.reduce<Record<string, number>>((acc, col, idx) => {
          const key = String(col ?? '').trim();
          if (key) {
            acc[key] = idx;
          }

          return acc;
        }, {});

        const hasAllRequiredHeaders = REQUIRED_HEADERS.every(
          header => headerIndexMap[header] !== undefined
        );

        if (!hasAllRequiredHeaders) {
          resolve([]);

          return;
        }

        const parsed: EmployeeRow[] = dataRows
          .filter(r => r.some(cell => cell !== ''))
          .map(r => ({
            customerName: String(r[headerIndexMap['ASA']] ?? '').trim(),
            serial: String(r[headerIndexMap['ŞV seriya №']] ?? '').trim(),
            fin: String(r[headerIndexMap['FİN']] ?? '').trim(),
            gsm: String(r[headerIndexMap['Mobil nömrə']] ?? '').trim(),
            employeePosition: String(r[headerIndexMap['Vəzifə']] ?? '').trim(),
          }));

        resolve(parsed);
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
